import React, { FC } from 'react';

import { LayoutListItemProps } from './LayoutList.types';
import { useIsLayoutListPresentational } from './LayoutListIsPresentationalContext';
import { getClassNames } from './LayouytListItem.styles.legacy';

/**
 * To be nested within a `LayoutList` component.
 */
const LayoutListItem: FC<LayoutListItemProps> = ({ children, className, fillWidth = false }) => {
  const isPresentational = useIsLayoutListPresentational();

  if (!children) {
    return null;
  }

  const { layoutListItem } = getClassNames(fillWidth, className);

  const ListElement = isPresentational ? 'div' : 'li';

  // Need to keep this class name for LayoutList's child selector styles.
  return <ListElement className={layoutListItem}>{children}</ListElement>;
};

export default LayoutListItem;
